import classNames from 'classnames';

import styles from './styles.module.scss';
const { input_container, input_field, input_label, error, has_error } = styles;

type Props = {
  label: string;
  name: string;
  placeholder?: string;
  required?: boolean;
  defaultInputValue?: string;
  rows?: number | string;
  register: ReturnType<typeof import('react-hook-form').useForm>['register'];
  errorMsg?: string;
  showError?: boolean;
};

const Textarea = ({
  label,
  name,
  placeholder = '',
  required = false,
  defaultInputValue = '',
  rows = 4,
  showError = false,
  errorMsg,
  register
}: Props) => {
  return (
    <div className={input_container}>
      {label && (
        <label className={input_label} htmlFor={name}>
          {label}
        </label>
      )}
      <textarea
        id={name}
        className={classNames(input_field, { [has_error]: errorMsg && showError })}
        placeholder={placeholder}
        rows={Number(rows)}
        defaultValue={defaultInputValue}
        required={required}
        {...register(name)}
      />
      {errorMsg && showError && <div className={error}>{errorMsg}</div>}
    </div>
  );
};

export default Textarea;
